import React from 'react'
import { Multi } from 'share/components/selects'
import { I18n } from 'share/services/i18n'
import createReactRoot from 'share/services/createReactRoot'

export default () => ({
  restrict: 'E',
  scope: {
    options: '=',
    ngModel: '='
  },
  link($scope, $element, $attrs) {
    let root = null;
    let isDestroyed = false;

    function cleanup() {
      if (root) {
        try {
          root.unmount();
        } catch (e) {
          // Ignore errors during cleanup
        }
        root = null;
      }
    }

    function render() {
      if (isDestroyed || !$element[0] || !$scope) {
        return;
      }

      const options = ($scope.options || []).map(group => ({
        value: group.id,
        label: group.name || group.id
      }));

      const value = Array.isArray($scope.ngModel) ? $scope.ngModel : ($scope.ngModel ? [$scope.ngModel] : []);

      // Ensure name ends with [] for Rails array parameters
      let name = $attrs.name || 'oncallGroupIds';
      if (!name.endsWith('[]')) {
        name = name + '[]';
      }

      const props = {
        name: name,
        value: value,
        options: options,
        onChange: (selectedValues) => {
          if (isDestroyed || !$scope) {
            return;
          }
          
          // Use $timeout to ensure we're not in a digest cycle
          setTimeout(() => {
            if (!isDestroyed && $scope) {
              if (!$scope.$$phase && !$scope.$root.$$phase) {
                $scope.$apply(() => {
                  if ($scope && !isDestroyed) {
                    $scope.ngModel = selectedValues;
                  }
                });
              } else {
                if ($scope && !isDestroyed) {
                  $scope.ngModel = selectedValues;
                }
              }
            }
          }, 0);
        },
        placeholder: I18n.t('ui.select.placeholder'),
        noResultsText: I18n.t('ui.select.no_results'),
        searchPromptText: I18n.t('ui.select.search_prompt')
      };

      try {
        if (!root) {
          root = createReactRoot($element[0]);
        }
        root.render(React.createElement(Multi, props));
      } catch (e) {
        console.error('Error rendering Multi component:', e);
      }
    }

    // Only re-render when options or value actually change
    let lastOptions = null;
    let lastValue = null;

    function shouldRender() {
      const optionsChanged = JSON.stringify($scope.options) !== JSON.stringify(lastOptions);
      const valueChanged = JSON.stringify($scope.ngModel) !== JSON.stringify(lastValue);
      
      if (optionsChanged) {
        lastOptions = $scope.options ? JSON.parse(JSON.stringify($scope.options)) : null;
      }
      if (valueChanged) {
        lastValue = $scope.ngModel ? JSON.parse(JSON.stringify($scope.ngModel)) : null;
      }
      
      return optionsChanged || valueChanged;
    }

    $scope.$watch('options', () => {
      if (shouldRender()) {
        render();
      }
    }, true);

    $scope.$watch('ngModel', () => {
      if (shouldRender()) {
        render();
      }
    }, true);

    $scope.$on('$destroy', () => {
      isDestroyed = true;
      cleanup();
    });

    // Initial render
    lastOptions = $scope.options ? JSON.parse(JSON.stringify($scope.options)) : null;
    lastValue = $scope.ngModel ? JSON.parse(JSON.stringify($scope.ngModel)) : null;
    render();
  }
});


